module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHtQTFRFpn9GqwUF/AgI8l1d+AAA/+Li/8HB/+fnupBU9dHR7gIC2paWjGEouo5TyC8vwAAA/O3tt5NV/XFxm3NAshkZ/gAA9AAAsoBawIxj2wEB/T4+oAAAq4ZXwolb0QAA4gAA/BgY/t/f/Q0N9KChpHk54Li4/Ssr/QAA////BSA5DAAAACl0Uk5T/////////////////////////////////////////////////////wBS9CCHAAAAcElEQVR42lzNxxLCIABF0QekW6KxAoYayv9/oeBCZ7y7s7rYPzxjS5dr2J6diDH6vrcVrXHURCHMqcBGlxJ1lFtsa1uRbnflC6yZ9NSkhjNgHTkhs9JaHYFD9iHsrlJKApw/izGU8Brytz9cfngLMACBjQ/uteE8AAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag_red.png
// module id = 6mCP
// module chunks = 1